import React, { useState, useEffect, useRef } from 'react';
import NotificationCard from './NotificationCard';
import Slider from 'react-slick';
import { checkLoggedIn } from '../../utills';
import { AddPriceCardDataonClick } from '../../pages/listing/addpricecard.utils';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './notification-card.scss';
import { debounceFunc, getNotificationCards } from './utils';
import { getOutDatedPriceCardData } from '../Feature/OutDatedPriceCard/utils';
import { clickTrack, filterQuery, toggleSupportSlider } from '../../actions/products';
import { setSlider } from '../../pages/listing/Notifications/redux/action';
import { getCategoryMissingCardData } from '../Feature/CategoryMissing/utils';
import VisibilitySensor from 'react-visibility-sensor';

const CardSlider = props => {
    const getNotificationData = useSelector(state => state?.notifications?.counts);
    const profileObj = useSelector(state => state?.session?.profileObject);
    const isMobile = useSelector(state => state?.library?.deviceData?.isMobile);    
    const loggedUser = useSelector(state => state?.session?.user?.loggedUser?.userType);
    const [cardData, setCardData] = useState([])
    const [slider1Ref,updateRef1] = useState(null);
    const [slider2Ref,updateRef2] = useState(null);
    const [curIndex,updateIndex] = useState(0);
    const dispatch = useDispatch()
    const [showArrows, updateArrows] = useState({left: false,right: false});
    const timeout = useRef(null); 
    const firstLastElement = useRef(null);
    const dotRef = useRef(null);
    let history = useHistory();
    const sliderObj = {}
    const [dotState, setDotState] = useState(3)
    const cardsEle = useRef([]);
    const scrollCardFunc = (e) => {
        if (e.target.scrollWidth - e.target.clientWidth - e.target.scrollLeft < 1) {
            updateArrows({
                left: true,
                right: false
            });
        } else if (e.target.scrollLeft < 1) {
            updateArrows({
                left: false,
                right: true
            });
        } else {
            updateArrows({
                left: true,
                right: true
            });
        }
    }

    const debouncedScrollHandler = debounceFunc(scrollCardFunc, 100);

    useEffect(() => {
        const element = document.getElementById("no-price-borders");
        if (!element) return;
        element.addEventListener("scroll", debouncedScrollHandler);
        return () => {
            element.removeEventListener("scroll", debouncedScrollHandler);
        }
    }, [])
    

    useEffect(() => {
        setCardData(getNotificationCards(getNotificationData || {}, {profileTypePlural:profileObj.PluralLabelWithSpace, profileTypeSingular:profileObj.SingleLabelWithSpace},(loggedUser ? loggedUser : '')) || [])
    }, [getNotificationData])

    useEffect(() => {
        const el = document.getElementById("no-price-borders");
        if(!isMobile && cardData.length && (cardData.length * 375) > window.innerWidth && (el?.scrollLeft < 1 || !el)) {
            updateArrows({
                left: false,
                right: true
            });
        }
    },[cardData])

    useEffect(() => {
        if(isMobile) {
            if(curIndex == cardData.length - 1) {
                timeout.current = setTimeout(() => {
                    slider1Ref.slickGoTo(0)
                }, 4000);
            }else if(timeout.current) {
                clearTimeout(timeout.current)
                timeout.current = null;
            }
        }
    },[curIndex])

    useEffect(() => {
        if(curIndex == 0 && slider2Ref) {
            dotRef.current.scrollIntoView({behavior:'smooth',block:'center',inline: 'start'})
        }
    },[slider2Ref])

    const isOverlapped = (element) => {
        const rect = element.getBoundingClientRect();
        const overlappingElement = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
        return overlappingElement && !element.contains(overlappingElement);
    }

    const recordImpression = (label) => {
        let li = '',ll = 'digital_catalog',userBased = true;
        switch(label) {
            case 'priceMissingCount':
                li = 'withoutprice_imp';
                break;
            case 'imgMissingCoun':
                li = 'withoutimage_imp';
                break;
            case 'descMissingCount':
                li = 'withoutdesc_imp';
                break;
            case 'specMissingCount':
                li = 'withoutspec_imp';
                break;
            case 'smartPriceMissingCount':
                li = 'outdatedprice_imp';
                break;
            case 'scoreLessThanHundred':
                li = 'productscoreless100_imp';
                break;
            case 'nonexistingjdmartidcount':
                li = 'catmissing_prod_imp';
                break;
            case 'rejectedCount':
                li = 'rejected_imp';
                break;
            case 'catalogSupport': 
                li = 'support_sc_imp';
                userBased = false
                break; 
        }
        if(li)
            dispatch(clickTrack({li,ll,userBasedCheck: userBased}));
    }


    const handlePriceCard = (cur, prflLbl) => {
                dispatch(setSlider(false));
                let li = '',ll = '',userBased = true;
                switch (cur) {
                    case "priceMissingCount":
                        checkLoggedIn({
                            cb: async () => {
                                await AddPriceCardDataonClick();
                            },
                            history
                        })
                        break;
                    case "smartPriceMissingCount":
                        checkLoggedIn({
                            cb: async () => {
                                await getOutDatedPriceCardData();
                            },
                            history
                        })
                        break;
                    case "nonexistingjdmartidcount":
                        checkLoggedIn({
                            cb: async () => {
                                await getCategoryMissingCardData();
                            },
                            history
                        })
                        break;
                    case "imgMissingCoun":
                        li = 'add_img'; 
                        ll = 'digital_catalog';
                 
                        sliderObj.name = `Add Image`
                        sliderObj.slidertype = cur
                        // sliderObj.filterObj = `&imagePresent=no`;
                        props.sliderObj(sliderObj)
                        props.cardClickHandler({filter:`&imagePresent=no`,name:`Add Image`,count:getNotificationData?.imgMissingCount,type: cur})
                        // props.actionCardSLider(true)
                        break;
                    case "specMissingCount":
                        li = 'add_spec';
                        ll = 'digital_catalog';
                        sliderObj.name = `Add Specification`
                        sliderObj.slidertype = cur
                        // sliderObj.filterObj = `&specPresent=no`;
                        props.sliderObj(sliderObj)
                        props.cardClickHandler({filter:`&specPresent=no`,name:`Add Specification`,count:getNotificationData?.specMissingCount,type: cur})
                        // props.actionCardSLider(true)
                        break;
                    case "descMissingCount":
                        li = 'add_desc';
                        ll = 'digital_catalog';
                        sliderObj.name = `Add Description`
                        sliderObj.slidertype = cur
                        // sliderObj.filterObj = `&descPresent=no`;
                        props.sliderObj(sliderObj)
                        props.cardClickHandler({filter:`&descPresent=no`,name: `Add Description`,count:getNotificationData?.descMissingCount,type: cur})
                        // props.actionCardSLider(true)
                        break;
                    case "rejectedCount":
                        // const rejInd = props.pendingTabs?.tabs?.length ? props.pendingTabs?.tabs?.findIndex(item => item?.tabKey == "rejected") : 0
                        // dispatch(setTabStatus({ tabKey: "rejected" }))
                        // dispatch(setPreviousTabIndex({ tabIndex: rejInd }));
                        // dispatch(filterQuery({}))
                        li = 'rejected_prod';
                        ll = 'digital_catalog';
                        sliderObj.name = `Rejected ${prflLbl}`
                        sliderObj.slidertype = cur
                        //  sliderObj.filterObj = `&tab=rejected`;
                        props.sliderObj(sliderObj)
                        props.cardClickHandler({filter:`&tab=rejected`,name: `Rejected ${prflLbl}`,count:getNotificationData?.rejectedCount,type: cur})
                        break;
                    case "scoreLessThanHundred":
                        li = 'prod_score';
                        ll = 'digital_catalog';
                        sliderObj.name = `Low ${prflLbl} Score`
                        sliderObj.slidertype = cur
                        // sliderObj.filterObj = `&score=lessThanHundred`;
                        props.sliderObj(sliderObj)
                        props.cardClickHandler({filter:`&score=lessThanHundred`,name: `Low ${prflLbl} Score`,count:getNotificationData?.scoreLessThanHundred,type: cur})
                        break;
                    case "catalogSupport":
                        li = 'support_sc_click';
                        ll = 'digital_catalog';
                        userBased = false;
                        dispatch(toggleSupportSlider({show: true}));
                    default:
                        dispatch(filterQuery(''))
                }
                if(!['priceMissingCount','smartPriceMissingCount','nonexistingjdmartidcount'].includes(cur))
                    dispatch(clickTrack({ li,ll,userBasedCheck: userBased }))
    }

    useEffect(() => {
        if(cardData.length && !isMobile){
            let cards = Array.from(document.querySelectorAll('.no-price-container'));
            cards.map((cur,index) => {
                cardsEle.current[index] = {...cardsEle.current[index],ele: cur};
            })
        }
    },[cardData])

    let children = cardData.length > 0 && cardData.map((cur,index) => {
        return <VisibilitySensor onChange={(isVisible) => {
            if(isVisible) {
                if(!isOverlapped(cardsEle.current[index].ele)){
                    recordImpression(cur.label);
                }
            }
            cardsEle.current[index] = {ele: cardsEle.current[index].ele,isVisible: isVisible}
        }}>
                    <NotificationCard 
                        title={cur.title}
                        hint={cur.hint}
                        btnClick={()=> handlePriceCard(cur.label, cur.prflLbl)}
                        label={cur.label}
                        Icon={cur.Icon}
                        btnTxt={cur.btnTxt}
                        updateRef={ref => {
                            if(index == 0) {
                                firstLastElement.current = {first: ref}
                            }else if((cardData.length - 1) == index) {
                                firstLastElement.current = {...firstLastElement.current,last: ref}
                            }
                            cardsEle.current[index] = {ele: ref};
                        }} 
                        profileObj={profileObj}
                        isMobile={isMobile}
                    />
        </VisibilitySensor> 
        
    })

    const arrowClick = (direction) => {
        if(direction == 'right'){
            var isMidEle = false;
            var firstVisibleIndex = '';
            for(var index = 0; index < cardsEle.current.length ; index++) {
                let cur = cardsEle.current[index];
                if(!cur.isVisible && typeof firstVisibleIndex == 'number' && index > firstVisibleIndex) {
                    cardsEle.current[index + 1 < cardsEle.current.length ? index + 1 : index].ele.scrollIntoView({behavior: 'smooth',inline: 'center',block: 'center'});
                    isMidEle = true;
                    break;
                }else if(cur.isVisible && typeof firstVisibleIndex == 'string') {
                    firstVisibleIndex = index;
                }
            }
            if(!isMidEle) {
                firstLastElement.current?.last?.scrollIntoView({behavior: 'smooth',inline: 'start',block: 'center'});
                updateArrows({left: true,right: false});
            }
        }else {
            var isMidEle = false;
            var firstVisibleIndex = '';
            for(var index = cardsEle.current.length - 1; index > 0  ; index--) {
                let cur = cardsEle.current[index];
                if(!cur.isVisible && typeof firstVisibleIndex == 'number' && index < firstVisibleIndex) {
                    cardsEle.current[index - 1 > 0 ? index - 1 : index].ele.scrollIntoView({behavior: 'smooth',inline: 'center',block: 'center'});
                    isMidEle = true;
                    break;
                }else if(cur.isVisible) {
                    firstVisibleIndex = index;
                }
            }
            if(!isMidEle) {
                firstLastElement.current?.first?.scrollIntoView({behavior: 'smooth',inline: 'start',block: 'center'});
                updateArrows({left: false,right: true})
            }
        }
    }

    const settings = {
        dots: false,
        infinite: false,
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 500,
        slidesToShow: 1,
        slide: '.no-price-borders',
        id: 'no-price-borders',
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        focusOnSelect: false, 
        //centerPadding: '20px 0 0',
        centerPadding: "10%",
        asNavFor: slider2Ref,
        beforeChange: (cur,newIndex) => {
            updateIndex(newIndex)
            let tempLength = 2
            if (newIndex == 0){
                tempLength = 3
            }
            //commmented code for future suggestion
            // setDotState(tempLength)
            // let tempLength = 2
            if (newIndex == 1){
                // tempLength = 3
                dotRef.current?.scroll({block: 'center',inline: 'center'});
            }
            // else if (cur == cardData.length - 1  && newIndex == 0){
            //     dotRef.current.scrollIntoView({block: 'center',inline: 'start'});   
            // }
        },
        afterChange: (cur,newIndex) => {
            dotRef.current?.scroll({block: 'center',inline: cur == 0 ? 'start' : cur == cardData.length - 1 ? 'end' : 'center'});
        }

    }
    if (isMobile){
        settings.className = 'iframe-border'
    }else {
        delete settings.className
    }
        
    const Wrapper = isMobile ? Slider : 'div'; 
    return (
        cardData.length ? 
            <div className={styles['notification-slider']}>
                <Wrapper
                    className={!isMobile? styles['web-view']: ''}
                    {...settings}
                    ref={slider1 => updateRef1(slider1)}
                >
                    {children}
                </Wrapper>
                {showArrows.left ? <div
                    role="button"
                    aria-label="Scroll cards left"
                    tabIndex={-1}
                    className={`${styles['arrow-btn']} ${styles['left']}`}
                    onClick={() => arrowClick('left')}
                >
                    <i aria-hidden="true" className='icon-pagination-left' />
                </div> : null}
                {showArrows.right ? <div
                    role="button"
                    aria-label="Scroll cards right"
                    tabIndex={-1}
                    className={`${styles['arrow-btn']} ${styles['right']}`}
                    onClick={() => arrowClick('right')}
                >
                    <i aria-hidden="true" className='icon-pagination-right' />
                </div> : null}
            </div> 
        : null
    )
};

export default CardSlider;